export const initialState = {
  pendingItems: [], // Items being added but not yet confirmed by the server
  pendingTotal: 0 // Total quantity of items being added
};

export const optimisticCartInitialState = initialState;

export default function optimisticCartReducer(state = initialState, action) {
  switch (action.type) {
    case "ADD_OPTIMISTIC_ITEM":
      return {
        ...state,
        pendingItems: [...state.pendingItems, action.payload],
        pendingTotal: state.pendingTotal + action.payload.quantity
      };
    case "CLEAR_OPTIMISTIC_ITEMS":
      return {
        ...state,
        pendingItems: [],
        pendingTotal: 0
      };
    default:
      return state;
  }
}
